<efx-modal
  [title]="title || functions?.name || 'Función'"
  [(show)]="openModal"
  (cancel)="onCancel()"
  (onHide)="onCancel()"
  [showFooter]="false"
  [size]="functionFields.length === 4 ? modalSize.medium : modalSize.extraLarge"
>
  <form [formGroup]="form" class="container-fluid p-0">
    <div class="row">
      <div class="col-lg-12 mb-3">
        <div class="text-muted">
          {{ functions?.description || 'Completa los valores para ejecutar la función seleccionada.' }}
        </div>
      </div>


      <div class="col-lg-12" formArrayName="functionFields">
        <div class="row">
        @for (fieldGroup of functionFields.controls; track $index; let i = $index) {
        <div

          [ngClass]="{ 'col-lg-12': functionFields.length <= 4, 'col-lg-6': functionFields.length > 4 && functionFields.length <= 8, 'col-lg-4': functionFields.length > 8 }"
          [formGroupName]="i"
          class="mb-3"
        >
        <div class="border rounded p-3 h-100">
          <div class="row">
            <div class="col-md-6 mb-2">
              <label class="form-label">Campo</label>
              <input class="form-control px-0" [value]="getFieldLabel(fieldGroup)" readonly title="Campo" placeholder="Campo" />
            </div>

            <div class="col-md-6 mb-2">
              <label class="form-label">Valor</label>
              @if (isEditableType(fieldGroup.get('type')?.value)) {
                @if (getInputType(fieldGroup) === 'select') {
                  <select class="form-control" formControlName="value" title="Valor" [class.is-invalid]="hasValueError(fieldGroup)"
                    (change)="onSelectChange(fieldGroup, $event.target['value'])">
                    <option value="">Seleccione una opción</option>
                    @for (option of getSelectOptions(fieldGroup); track $index) {
                      <option [value]="option?.value">{{ option?.text || option?.value }}</option>
                    }
                  </select>
                } @else if (getInputType(fieldGroup) === 'number') {
                  <input class="form-control" type="number" formControlName="value" placeholder="Ingresa el valor"
                    [class.is-invalid]="hasValueError(fieldGroup)" />
                } @else if (getInputType(fieldGroup) === 'date') {
                  <input class="form-control" type="date" formControlName="value" placeholder="Ingresa la fecha"
                    [class.is-invalid]="hasValueError(fieldGroup)" />
                } @else {
                  <input class="form-control" formControlName="value" placeholder="Ingresa el valor"
                    [class.is-invalid]="hasValueError(fieldGroup)" />
                }
                @if (hasValueError(fieldGroup)) {
                  <div class="invalid-feedback d-block">{{ getValueErrorMessage(fieldGroup) }}</div>
                }
              } @else if (fieldGroup.get('type')?.value === 'date') {
              <input class="form-control" formControlName="value" readonly title="Fecha actual"
                placeholder="Fecha actual" />
              } @else if (fieldGroup.get('type')?.value === 'user') {
              <input class="form-control" formControlName="value" readonly title="Usuario" placeholder="Usuario" />
              } @else if (fieldGroup.get('type')?.value === 'custom') {
              <input class="form-control" formControlName="value" readonly title="Valor personalizado"
                placeholder="Valor personalizado" />
              } @else {
              <input class="form-control" formControlName="value" readonly title="Valor" placeholder="Valor" />
              }
            </div>
          </div>
        </div>
        </div>
        }
        </div>
      </div>
    </div>

    @if (showComentarioAudit) {
      <div class="col-lg-12 mt-3">
        <label class="efx-label" for="comentarioAuditFn">Comentario</label>
        <textarea
          class="efx-textarea w-100"
          id="comentarioAuditFn"
          formControlName="comentarioAudit"
          cols="40"
          rows="3"
        ></textarea>
      </div>
    }

    <div class="d-flex justify-content-end gap-2 mt-3">
      <button type="button" class="efx-button-secondary" (click)="onCancel()">Cancelar</button>
      <button type="button" class="efx-button-primary" (click)="onSubmit()">Aplicar</button>
    </div>
  </form>
</efx-modal>
